import {
    loginService,
    forgotPasswordService,
    resetPasswordService,
    updatePasswordService,
    validateSetPasswordTokenService,
    loginImageService,
    ssoAuthService,
    portalLoginService,
    submitInitialEmailService,
} from '../../services/authServices';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();

export async function loginUser(dispatch, loginPayload, ssoAuth = false) {
    try {
        dispatch({ type: 'REQUEST_LOGIN' });
        let response;
        if (ssoAuth) {
            response = await ssoAuthService(loginPayload);
        } else {
            response = await loginService(loginPayload);
        }

        if (response.data) {
            dispatch({ type: 'LOGIN_SUCCESS', payload: response.data.user });
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('token', JSON.stringify(response.data.token));
            localStorage.setItem('driverportal_version', response.headers.driverportal_version);
            localStorage.setItem('driverportal_logout_version', response.headers.driverportal_logout_version);
            // Backup auth to native layer (AsyncStorage) so it survives WebView process termination
            window.postToRN?.({ type: 'authToken', token: response.data.token, user: response.data.user });
            return response.data;
        }

        dispatch({
            type: 'LOGIN_ERROR',
            error: response.data.errorMessage ? response.data.errorMessage : 'Error occured while login ',
        });
        return response.data.errorMessage ? response.data.errorMessage : 'Error occured while login ';
    } catch (error) {
        dispatch({
            type: 'LOGIN_ERROR',
            error: error.response.data.message ? error.response.data.message : 'Invalid Email or password!',
        });
    }
}

export async function portalLogin(dispatch, loginPayload) {
    try {
        dispatch({ type: 'REQUEST_LOGIN' });
        let response = await portalLoginService(loginPayload);

        if (response.data) {
            return response.data;
        }

        dispatch({
            type: 'LOGIN_ERROR',
            error: response.data.errorMessage ? response.data.errorMessage : 'Error occured while login ',
        });
        return response.data.errorMessage ? response.data.errorMessage : 'Error occured while login ';
    } catch (error) {
        dispatch({
            type: 'LOGIN_ERROR',
            error: error.response.data.message ? error.response.data.message : 'Invalid Email or password!',
        });
    }
}

export async function submitInitialEmail(dispatch, emailAddress) {
    try {
        let response = await submitInitialEmailService(emailAddress);
        if (response.data) {
            return response.data;
        }
        dispatch({
            type: 'LOGIN_ERROR',
            error: response.data.errorMessage ? response.data.errorMessage : 'Error occurred while fetching portals',
        });
        return null;
    } catch (error) {
        dispatch({
            type: 'LOGIN_ERROR',
            error: error.response?.data?.message
                ? error.response.data.message
                : 'Error occurred while fetching portals',
        });
        throw error;
    }
}

export async function forgotPassword(payload, scope) {
    const response = await forgotPasswordService(payload, scope);
    return response.data;
}

export async function validateSetPasswordToken(token) {
    const response = await validateSetPasswordTokenService(token);
    return response.data;
}

export async function resetPassword(payload) {
    const response = await resetPasswordService(payload);
    return response.data;
}

export async function updatePassword(dispatch, data) {
    try {
        const response = await updatePasswordService(data);
        dispatch({ type: 'UPDATE_DRIVER_SUCCESS', payload: response.data });
        return response.data;
    } catch (error) {
        dispatch({ type: 'UPDATE_DRIVER_ERROR', error });
        throw error;
    }
}

export async function getLoginImage(dispatch) {
    try {
        let response = await loginImageService();
        if (response.data) {
            dispatch({ type: 'GET_LOGIN_IMAGE_SUCCESS', payload: response.data });
            return response.data;
        }

        dispatch({ type: 'GET_LOGIN_IMAGE_ERROR', error: response.data.errors[0] });
        return;
    } catch (error) {
        dispatch({ type: 'GET_LOGIN_IMAGE_ERROR', error: error });
    }
}
